import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { FormDropDownList, FormTextArea } from 'commons/forms/form';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import CustomModal from 'commons/modal/CustomModal';
import FormFooterWithAccess from 'commons/modal/FormFooterWithAccess';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useGetDocTypeMetaQuery } from '../../../../redux/api/cache';

export default function CreateFileNoteModal(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const { data: META } = useGetDocTypeMetaQuery();

  const handleSubmit = (dataItem) => {
    props.create({
      docm_descr: dataItem.campmn_titre,
      docm_val: dataItem.campmn_note,
      rid_doc: props.meta?.rid,
      rid: props.selectedRow?.rid,
      docm_visible: true
    });
    props.toggleDialog();
  };

  const getMax = () => {
    let descr = props.selectedRow.docm_descr;
    let max = descr.replace(/^\D+/g, '');
    let temp = max[0] + max[1] + max[2];

    return temp;
  };

  return (
    <div>
      <CustomModal
        width={'50%'}
        title='Note'
        onClose={props.toggleDialog}
        body={
          <Form
            initialValues={{
              campmn_note: props.selectedRow?.docm_val,
              campmn_titre: props.selectedRow?.docm_descr,
            }}
            onSubmit={handleSubmit}
            render={(formRenderProps) => (
              <FormElement>
                <fieldset className={'k-form-fieldset'}>
                  <legend className={'k-form-legend'}>{`AJOUT D'UNE NOTE`}</legend>
                  <div style={{ display: 'flex' }}>
                    <Field
                      id={'campmn_titre'}
                      name={'campmn_titre'}
                      label={`Type`}
                      component={FormDropDownList}
                      data={META?.data?.map((x) => x.typeMeta)}
                      wrapperStyle={{ width: '40%', marginRight: '18px' }}
                    />
                    <Field
                      id={'campmn_note'}
                      name={'campmn_note'}
                      label={'Note'}
                      component={FormTextArea}
                      rows={3}
                      maxLength={
                        props.selectedRow?.docm_descr?.includes('Max')
                          ? getMax()
                          : 1000
                      }
                      wrapperStyle={{ width: '60%' }}
                    />
                  </div>
                  <FormFooterWithAccess
                    selectedRow={props.selectedRow}
                    formRenderProps={formRenderProps}
                    delete={() => {
                      setDeleteModalVisible(true);
                    }}
                  />
                </fieldset>
              </FormElement>
            )}
          />
        }
      />
      {deleteModalVisible && (
        <ConfirmationModal
          text={`Supprimer ${props.selectedRow.campmn_titre} ?`}
          onClose={() => {
            setDeleteModalVisible(false);
          }}
          onConfirm={() => {
            setDeleteModalVisible(false);
            props.toggleDialog();
            props.remove();
          }}
        />
      )}
    </div>
  );
}
CreateFileNoteModal.propTypes = {
  create: PropTypes.func,
  meta: PropTypes.shape({
    rid: PropTypes.any,
  }),
  remove: PropTypes.func,
  selectedRow: PropTypes.shape({
    campmn_note: PropTypes.any,
    campmn_titre: PropTypes.any,
    rid: PropTypes.any,
    docm_val: PropTypes.any,
    docm_descr: PropTypes.any
  }),
  toggleDialog: PropTypes.func,
};
